/* ============================================================
   ProtoClinical — global.js
   Dependency-free progressive enhancements that must run on every
   page (incl. password): prefetch-on-intent, predictive search,
   and the country/language disclosure. Keeps navigation feeling
   instant without blocking anything.
   ============================================================ */
(function () {
  "use strict";
  var CFG = window.PC_CONFIG || {};
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  /* ---- Prefetch on hover / intent (instant.page style) ---- */
  (function prefetch() {
    const conn = navigator.connection;
    if (conn && (conn.saveData || /2g/.test(conn.effectiveType || ""))) return;
    const seen = new Set();
    let timer = null;
    function add(url) {
      if (!url || seen.has(url)) return;
      try {
        const u = new URL(url, location.href);
        if (u.origin !== location.origin) return;
        if (u.pathname === location.pathname && u.search === location.search) return;
      } catch (e) { return; }
      seen.add(url);
      const l = document.createElement("link");
      l.rel = "prefetch"; l.href = url; l.as = "document";
      document.head.appendChild(l);
    }
    function candidate(e) {
      const a = e.target.closest("a[href], [data-prefetch][href]");
      if (!a) return null;
      const href = a.getAttribute("href");
      if (!href || href.startsWith("#") || href.startsWith("mailto:") || href.startsWith("tel:")) return null;
      if (a.hasAttribute("data-no-prefetch")) return null;
      return a.href;
    }
    document.addEventListener("mouseover", (e) => {
      const url = candidate(e); if (!url) return;
      clearTimeout(timer); timer = setTimeout(() => add(url), 65);
    });
    document.addEventListener("mouseout", () => clearTimeout(timer));
    document.addEventListener("touchstart", (e) => { const url = candidate(e); if (url) add(url); }, { passive: true });
  })();

  /* ---- Predictive search ---- */
  (function predictive() {
    const input = $("[data-predictive-search-input]");
    const results = $("[data-predictive-search-results]");
    if (!input || !results) return;
    const base = (CFG.routes && CFG.routes.predictiveSearch) || "/search/suggest";
    let timer = null, controller = null;
    const trendingHTML = results.innerHTML;

    function money(cents) {
      try { return (cents / 100).toLocaleString(undefined, { style: "currency", currency: "USD" }); }
      catch (e) { return "$" + (cents / 100).toFixed(2); }
    }
    function render(products) {
      if (!products || !products.length) { results.innerHTML = '<h5>' + (results.dataset.noResults || 'No matches') + '</h5>'; return; }
      results.innerHTML = "<h5>Products</h5>" + products.map((p) => {
        const img = (p.featured_image && p.featured_image.url) ? `<img src="${p.featured_image.url}&width=80" alt="" width="40" height="40" loading="lazy">` : "";
        return `<a href="${p.url}" data-prefetch><span class="sg-thumb ph">${img}</span><span class="sg-name">${p.title}</span><span class="sg-price mono">${money(p.price)}</span></a>`;
      }).join("");
    }
    function search(q) {
      if (controller) controller.abort();
      controller = new AbortController();
      const url = `${base}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`;
      fetch(url, { signal: controller.signal })
        .then((r) => r.json())
        .then((data) => render(data.resources && data.resources.results && data.resources.results.products))
        .catch(() => {});
    }
    input.addEventListener("input", () => {
      const q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { results.innerHTML = trendingHTML; return; }
      results.setAttribute("aria-busy", "true");
      timer = setTimeout(() => { search(q); results.removeAttribute("aria-busy"); }, 220);
    });
  })();

  /* ---- Country / language disclosure ---- */
  (function disclosure() {
    $$("[data-disclosure]").forEach((d) => {
      const btn = $(".loc-select__btn", d);
      const list = $(".loc-list", d);
      if (!btn || !list) return;
      const close = () => { list.hidden = true; btn.setAttribute("aria-expanded", "false"); };
      const open = () => { list.hidden = false; btn.setAttribute("aria-expanded", "true"); };
      btn.addEventListener("click", (e) => { e.stopPropagation(); list.hidden ? open() : close(); });
      document.addEventListener("click", (e) => { if (!d.contains(e.target)) close(); });
      document.addEventListener("keydown", (e) => { if (e.key === "Escape") close(); });
    });
  })();
})();
